import React from "react"
import { cn } from "lib/utils"
import { useTemplatePreviewCtx } from "lib/units/template/preview/TemplatePreviewProvider";
import { useRenderStyling } from "lib/hooks/useRenderStyling"

export default function SummaryBlockRender(){

  const { parseApiData }:any = useTemplatePreviewCtx()

  const blockStyling = useRenderStyling("w-20/24 flex justify-end border border-solid border-gray-800", "styleObj")
  const outerStyling = useRenderStyling("bg-neutral-200 border border-solid border-neutral-700 rounded-md flex flex-col pl-2 pb-2", "styleObj")
  const amtStyling = useRenderStyling("w-full text-2xl font-extrabold border-b-4 border-b-solid border-b-neutral-800 mb-3", "styleObj")
  const reasonCodeStyling = useRenderStyling("w-full flex flex-col leading-tight", "styleObj")
  const descriptionStyling = useRenderStyling("whitespace-nowrap", "styleObj")

  return(
    <div id="mm-summary-block" { ...blockStyling}>
      <div { ...outerStyling}>
        <div {...amtStyling}>
          Amount: { parseApiData("[[rp.Chargeback.Amount]]").result }
        </div>
        <div {...reasonCodeStyling}>
          <span>Reason Code: { parseApiData("[[rp.ReasonCode]]").result }</span>
          { parseApiData("[[rp.ReasonCodeDescription]]").result !== "rp.ReasonCodeDescription" && (
            <span {...descriptionStyling}>Reason Description: { parseApiData("[[rp.ReasonCodeDescription]]").result }</span>
          )}
        </div>
      </div>
    </div>
  )
}